<template>
    <header class="mdc-top-app-bar view-header"
        :style="basicData.thumbnail ? `background-image: url(${basicData.thumbnail}?s=360x256&t=fill&q=10&b=5);` : ''"
        :class="basicData.thumbnail ? 'darken' : ''"
        v-if="basicData">
        
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">arrow_back</a> -->
                <a class="material-icons mdc-top-app-bar__navigation-icon" @click="moveLearnList">arrow_back</a>
                <!-- moveLearnList() -->
            </section>
            
            <section class="mdc-top-app-bar__section title">
                <div class="mdc-top-app-bar__title"></div>                
            </section>

            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                <div class="mdc-menu-surface--anchor">
                        
                    <!-- <a href="#" class="material-icons mdc-top-app-bar__action-item" aria-label="more_vert" alt="more_vert" 
                        @click.prevent="toggleAddedMenu">more_vert</a> -->
                    <div class="mdc-menu mdc-menu-surface" tabindex="-1" id="addedMenu">

                        <ul class="mdc-list">
                            
                            <li class="mdc-list-item">
                                <span class="mdc-list-item__text">
                                    {{$t('210')}}
                                    <!-- 과정 개요 -->
                                </span>
                            </li>
                            <li class="mdc-list-item">
                                <span class="mdc-list-item__text">
                                    {{$t('211')}}
                                    <!-- 리워드 -->
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </section>
        </div>
        <div class="pdt-16 pdb-20 pdl-16 pdr-16">
            <div class="t-headline6">
                {{basicData.name}}
            </div>
            <div class="t-body4 mgt-8">
                {{basicData.category.text}}{{basicData.category.child ? ' > ' + basicData.category.child.text : ''}}
            </div>
            <div class="t-body4 mgt-4" v-if="basicData.levels.length">
                <span v-for="(level, index) in basicData.levels" :key="index">
                    {{level.text}} {{basicData.levels.length === index+1 ? '' : '/' }}
                </span>
            </div>
            <div class="t-helper mgt-9 d-flex flex-row" v-if="basicData.tags.length">
                <span class="chip mgr-8" v-for="(tag, index) in basicData.tags" :key="index">#{{tag.name}}</span>
            </div>
            <div class="mgt-18 d-flex flex-row justify-content-between align-items-baseline t-headline5">
                <div>
                    {{$t('138', {str: parseInt(basicData.progression)})}}
                </div>
                <div v-if="basicData.learnRemainDays <= 30">
                    {{$t('156', {str: basicData.learnRemainDays})}}
                </div>
            </div>
        </div>
        
        
        
    </header>
</template>

<script>
/**
 * 나의 학습 상세 - header 컴포넌트(my learning view - header component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCMenuSurface} from '@material/menu-surface'

export default {
    props: ['basicData'],
    data() {
        return {
            addedMenu: null
        }
    },
    
    updated() {
        // 네비게이션 메뉴 설정(set navigation menu)
        this.addedMenu = MDCMenuSurface.attachTo(document.getElementById('addedMenu'))
        this.addedMenu.setAnchorMargin({
            bottom: 10,
            left: 10,
            right: 16,
            top: 40,
        })
        
    },

    methods: {
        // 네비게이션 메뉴 토글(toggle navigation menu)
        toggleAddedMenu() {
            this.addedMenu.open = !this.addedMenu.open
        },

        // move list
        moveLearnList() {
            this.$router.push({
                name: 'HelpDesk',
                query: this.$route.query
            })
        }
        
    }
}
</script>